import React, { FC } from 'react';
import { EntityType } from 'common/enums';
import {
    RADIO_HIERARCHY_OFFSET_CATEGORY,
    RADIO_HIERARCHY_OFFSET_INDICATOR,
    RADIO_HIERARCHY_OFFSET_SUBCATEGORY
} from 'common/config';

import './RadioButtonCellRenderer.scss';
import RadioButton from 'common/components/base/radio-button';
import Icon from 'common/components/base/icon';
import { ICON_COLLECTION } from 'assets/media/icons';
import { EntityVM } from 'common/models/data/entity.model';

type RadioButtonCellRendererProps = {
    value: string;
    data: any;
    onExpansionToggle: (data: any) => void;
    onClickRadioButton: (value: any) => void;
    hideChildIndicatorsOnly: boolean;
    hideSelectionOnCategory: boolean;
    disbleEntity?: EntityVM;
    preventSelectionOfSubCategoriesHavingSubCategories?: boolean;
    preventSelectionOfSubCategoriesHavingIndicators?: boolean;
};

const RadioButtonCellRenderer: FC<RadioButtonCellRendererProps> = ({
    value,
    data,
    disbleEntity,
    onExpansionToggle,
    onClickRadioButton,
    hideChildIndicatorsOnly,
    hideSelectionOnCategory,
    preventSelectionOfSubCategoriesHavingSubCategories,
    preventSelectionOfSubCategoriesHavingIndicators
}: RadioButtonCellRendererProps) => {
    const cellStyles = {
        marginLeft: `${
            data.level === 0
                ? RADIO_HIERARCHY_OFFSET_CATEGORY
                : data.entityType === EntityType.Indicator
                ? data.level * RADIO_HIERARCHY_OFFSET_INDICATOR
                : data.level * RADIO_HIERARCHY_OFFSET_SUBCATEGORY
        }px`
    };
    const expansionIndicationClass =
        data.isParentExpanded || data.isExpanded ? 'radio-button-cell-cell-expanded' : '';

    const nameValueClass = `name-value ${
        data.isExpanded
            ? 'name-value-expanded'
            : data.entityType === EntityType.Indicator
            ? 'name-value-light'
            : ''
    }`;
    const radioButton = () => {
        if (hideSelectionOnCategory && data.entityType === EntityType.Category) {
            return null;
        } else if (
            (disbleEntity &&
                disbleEntity.entityType === EntityType.Category &&
                disbleEntity.id === data.id) ||
            (disbleEntity &&
                disbleEntity.entityType === EntityType.SubCategory &&
                disbleEntity.hierarchyId === data.hierarchyId)
        ) {
            return (
                <RadioButton
                    name="addSubCategoryRadioButton"
                    id="addSubCategoryRadioButton"
                    className="radio-button-cell-button"
                    value={value}
                    disabled={true}
                    checked={data?.isSelected}
                    onChange={() => {
                        onClickRadioButton(data);
                    }}
                />
            );
        } else if (
            (preventSelectionOfSubCategoriesHavingSubCategories &&
                data.entityType === EntityType.SubCategory &&
                data.hasChild &&
                !data.hasChildIndicatorsOnly) ||
            (preventSelectionOfSubCategoriesHavingIndicators &&
                data.entityType === EntityType.SubCategory &&
                data.hasChildIndicatorsOnly)
        ) {
            return (
                <RadioButton
                    name="addSubCategoryRadioButton"
                    id="addSubCategoryRadioButton"
                    className="radio-button-cell-button"
                    value={value}
                    disabled={true}
                    checked={data?.isSelected}
                    onChange={() => {
                        onClickRadioButton(data);
                    }}
                />
            );
        } else {
            return (
                <RadioButton
                    name="addSubCategoryRadioButton"
                    id="addSubCategoryRadioButton"
                    className="radio-button-cell-button"
                    value={value}
                    checked={data?.isSelected}
                    onChange={() => {
                        onClickRadioButton(data);
                    }}
                />
            );
        }
    };
    return (
        <div className={`radio-button-cell ${expansionIndicationClass}`} title={value}>
            {radioButton()}
            <div className="radio-button-cell-contents" style={cellStyles}>
                {data.hasChild && hideChildIndicatorsOnly === !data.hasChildIndicatorsOnly ? (
                    data.isExpanded ? (
                        <Icon
                            className="name-icon name-icon-expanded"
                            src={ICON_COLLECTION.IC_ExpandMore}
                            onClick={() => onExpansionToggle(data)}
                        />
                    ) : (
                        <Icon
                            className="name-icon"
                            src={ICON_COLLECTION.IC_ChevronRight}
                            onClick={() => onExpansionToggle(data)}
                        />
                    )
                ) : (
                    <span className="name-icon" />
                )}
                {data.entityType !== EntityType.Indicator && (
                    <span className={nameValueClass}>{value}</span>
                )}
            </div>
        </div>
    );
};
export default RadioButtonCellRenderer;
